/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Agen_S1Inputs */

const en_mk_tut_agen_s1 = /** @type {(inputs: Mk_Tut_Agen_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the issue, click the **Assignee** field, and pick an agent’s name. The Marketing agent is called Kira, Finance & Ops is Rani, and so on.`)
};

const id_mk_tut_agen_s1 = /** @type {(inputs: Mk_Tut_Agen_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka issue, klik kolom **Assignee**, lalu pilih nama agen. Agen divisi Marketing bernama Kira, Finance & Ops bernama Rani, dan seterusnya.`)
};

/**
* | output |
* | --- |
* | "Open the issue, click the **Assignee** field, and pick an agent’s name. The Marketing agent is called Kira, Finance & Ops is Rani, and so on." |
*
* @param {Mk_Tut_Agen_S1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_agen_s1 = /** @type {((inputs?: Mk_Tut_Agen_S1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Agen_S1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_agen_s1(inputs)
	return en_mk_tut_agen_s1(inputs)
});